import { AfterContentInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MapSettings } from 'app/models/settings/map-settings';
import { BrowserWindowService } from 'app/services/browser-window.service';
import { CanComponentDeactivate } from 'app/services/pending-changes-guard.service';
import { ApplicationStore } from 'app/stores/application-store';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: './user-map-settings.component.html'
})
export class UserMapSettingsComponent implements OnInit, OnDestroy, CanComponentDeactivate, AfterContentInit {

  public scrollHeight: number;
  
  public mapSetting: MapSettings;
  
  // Drives the enablement of the save button
  public formValid: boolean = false;

  private map_settings_subscription: Subscription;

   @ViewChild('editMapSettings') editMapSettings;
   
  constructor(private applicationStore: ApplicationStore,
    private router: Router,
    private windowService: BrowserWindowService) {
    //subscribe to the window resize event
      this.windowService.height$.subscribe((value: number) => {
         this.scrollHeight = value - 185;
      });

      this.mapSetting = undefined;
  }

  ngAfterContentInit(): void {
   // Subscribe to the form state change event for each step.
      this.editMapSettings.formState$.subscribe((newState: boolean) => {
        this.formValid = newState;
      });
  }
  ngOnDestroy(): void {
    if (this.map_settings_subscription) {
         this.map_settings_subscription.unsubscribe();
      }
  } 

  canDeactivate():  boolean {
   // If the form is not pristine (ie dirty), then prompt the user to save any changes.
      return this.editMapSettings.mapSettingsForm.pristine;
  };

  ngOnInit() {
    this.subscribeToUserMapSettings();
    this.applicationStore.mapsStore.getUserMapSettings();
  }
  
  public submitForm() {
    this.editMapSettings.mapSettingsForm.form.markAsPristine();
    this.applicationStore.mapsStore.updateUserMapSettings(this.mapSetting);
  }

  public onCancel() {
    if(this.applicationStore.projectsStore.selectedProject === null) {
      this.router.navigate(['/open-project']);
    }
    else {
      this.router.navigate(['/dashboard']);
    }
  }

  private subscribeToUserMapSettings(): void {
    this.map_settings_subscription = this.applicationStore.mapsStore.userMapSettings$.subscribe(
      (mapSettings: MapSettings) => {
        if (mapSettings !== null) {
          this.mapSetting = mapSettings;
        }
      });
  }
}
